<template>
    <div class="vip-page pt-0px bg-#19100F min-h-100vh">
        <div class="vip-header pt-20px flex justify-between items-center px-20px absolute top-0 left-0 right-0 z-3">
            <div class="close w-24px h-24px " @click="handleClose">
                <img src="@/assets/images/vip/close.svg" alt="" class="w-full h-full"></img>
            </div>
            <div class="tab flex" v-if="![4,5].includes(userStore.userInfo?.role)">
                <div :class="index === tabActive ? activeColor : ''" class="tab-item" v-for="(item, index) in tabList"
                    :key="index" @click="handleTabClick(item, index)">
                    {{ item }}
                </div>
            </div>
            <div class="resore text-14px font-500 color-text-1" @click="handleRestore">
                <!-- {{ [4,5].includes(userInfo?.role) ? '' : 'restore' }} -->
            </div>
        </div>
        <vipU :vipBenefitList="vipBenefitList" v-if="tabActive === 0" :vipPerksUltra="vipPerks" ref="vipURef" />
        <vipPlus :vipBenefitList="vipBenefitList" v-if="tabActive === 1" :vipPerksPlus="vipPerks" ref="vipPlusRef" />
        <vip :vipBenefitList="vipBenefitList" :vipPerks="vipPerks" v-if="tabActive === 2" ref="vipRef" />
    </div>
</template>

<script setup lang="ts">
import bridge from '@/utils/bridge'
import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { vipBenefitList } from './index'
import vipU from './com/vipU.vue'
import vipPlus from './com/vipPlus.vue'
import vip from './com/vip.vue'
import { useVipStore } from '@/stores/vip'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
const router = useRouter()
const vipStore = useVipStore()
const route = useRoute()
const tabList = ['VIP Ultra', 'VIP Plus']
const tabActive = ref(2)
const vipPerks = computed(() => vipStore.vipPerks)
const activeColor = computed(() => {
    return tabActive.value === 0 ? 'vip_ultra' : tabActive.value === 1 ? 'vip_plus' : 'vip'
})
const userStore = useUserStore()

const vipRef = ref<InstanceType<typeof vip>>()
const vipPlusRef = ref<InstanceType<typeof vipPlus>>()
const vipURef = ref<InstanceType<typeof vipU>>()
const handleClose = () => {
    if (route.query.tab === 'chat') {
        router.back()
        return
    }
    if ([4, 5].includes(userStore.userInfo?.role)) {
        router.push({
            path: '/mine',
        })
    }
    if (tabActive.value === 2) {
        if ([3].includes(userStore.userInfo?.role)) {
            router.push({
                path: '/mine',
            })
        } else {
            if (vipRef.value) {
                console.log('vipRef.value', vipRef.value)
                vipRef.value.handleShowRetentionPopup()
            }
        }
    } else if (tabActive.value === 1) {
        if (vipPlusRef.value) {
            vipPlusRef.value.handleShowRetentionPopup()
        }
    } else {
        if (vipURef.value) {
            vipURef.value.handleShowRetentionPopup()
        }
    }
}


const handleTabClick = (item: any, index: number) => {
    tabActive.value = index
}
const handleRestore = () => {
    bridge.callApp('inAppRestore')
}
onMounted(async () => {
    vipStore.fetchVipPerks()
    const type = route.query.type as string
    if (type) {
        tabActive.value = type === 'u' ? 0 : type === 'p' ? 1 : 2
    }
})
</script>
<style scoped lang="scss">
.vip-header {
    .tab {
        border-radius: 20px;
        font-weight: 500;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        justify-content: center;

        .vip_ultra {
            // border-radius: 20px;
            background: linear-gradient(90deg, #A06EFA 0%, #FA6CCE 100%);
            -webkit-background-clip: text;
            background-clip: text;
            font-weight: 800;

            color: transparent !important;
        }

        .vip_plus {
            background: linear-gradient(0deg, #FFDFB3 0%, #EAB04E 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent !important;
            font-weight: 800;
        }

        .vip {
            // background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
            border-radius: 20px;
            background: linear-gradient(90deg, #CEDCFF 0%, #909BFF 100%);

        }

        .tab-item {
            color: #FFFFFF;

            &:nth-of-type(1) {
                width: 78px;
                text-align: center;
            }

            &:nth-of-type(2) {
                width: 70px;
                text-align: center;
            }

            &:nth-of-type(3) {
                width: 53px;
                text-align: center;
            }

        }
    }
}

.sparkle {
    position: absolute;
    font-size: 12px;
    color: #FFD700;
    animation: sparkle-twinkle 2s ease-in-out infinite;
}

.sparkle-top-left {
    top: -5px;
    left: -5px;
}

.sparkle-bottom-right {
    bottom: -5px;
    right: -5px;
    animation-delay: 1s;
}

@keyframes sparkle-twinkle {

    0%,
    100% {
        opacity: 0.5;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}
</style>